import gql from 'graphql-tag';
import { productGroupFragments } from './ProductGroup';

export const productFragments = gql`
  fragment productFragments on Product {
    id
    number
    name
    description
    vatRateSymbol
    taxExemptionReason
    unitOfMeasureCode
    productPrices {
      id,
      purchasePrice,
      salePrice
      validTo,
      validFrom,
      contributionMargin,
      contributionMarginPercentage,
    }
    car {
      id
      name
      registrationNumber
    }
    project {
      id
      code
      name
    }
    department {
      id
      code
      name
    }
    createdBy {
      id
      name
    }
    productGroup {
      ...productGroupFragments
    }
    productActivePeriods {
      id
      activeFrom
      activeTo
    }
    supplierUnit {
      id
      name
      highestPriorityIdentity {
        id
        value
        identificator {
          id
          name
        }
      }
      address
      city
      zip
      country {
        code
        name
      }
    }
    suppliersProductNumber
  },
  ${productGroupFragments}
`;

export const GET_PRODUCT = gql`
  query product($id: ID!) {
    product(id: $id) {
      ...productFragments,
      images {
        id
        signedBlobId
        fileName
        contentType
        url
        size
      }
    }
  },
  ${productFragments}
`;

export const UPDATE_PRODUCT = gql`
  mutation updateProduct(
    $id: ID!,
    $number: String,
    $name: String,
    $description: String,
    $vatRateSymbol: NorwegianVatSymbolEnum,
    $taxExemptionReason: String,
    $productPrices: [ProductPriceUpdate!],
    $unitOfMeasureCode: String,
    $carId: ID,
    $projectId: ID,
    $departmentId: ID,
    $productGroupId: ID,
    $supplierUnitId: ID,
    $images: [FileUpload!],
    $suppliersProductNumber: String,
    $productActivePeriods: [ProductActivePeriodUpdate!]
  ) {
    updateProduct(
      input: {
        product: {
          id: $id,
          number: $number,
          name: $name,
          description: $description,
          vatRateSymbol: $vatRateSymbol,
          taxExemptionReason: $taxExemptionReason,
          productPrices: $productPrices,
          unitOfMeasureCode: $unitOfMeasureCode,
          carId: $carId,
          projectId: $projectId,
          departmentId: $departmentId,
          productGroupId: $productGroupId,
          supplierUnitId: $supplierUnitId,
          images: $images,
          suppliersProductNumber: $suppliersProductNumber,
          productActivePeriods: $productActivePeriods
        }
      }
    ) {
      product {
        ...productFragments,
        images {
          id
          signedBlobId
          fileName
          contentType
          url
          size
        }
      }
    }
  },
  ${productFragments}
`;

export const PRODUCT_LIST_SEARCH = gql`
  query productListSearch(
    $limit: Int,
    $offset: Int,
    $orderBy: String,
    $orderDirection: String,
    $filters: ProductFilter
  ) {
    products(
      limit: $limit,
      offset: $offset,
      orderBy: $orderBy,
      orderDirection: $orderDirection,
      filters: $filters
    ){
      id
      number
      name
      productGroup {
        id
        fullPathName
      }

      vatRateSymbol
      car {
        id
        name
        registrationNumber
      }
      project {
        id
        code
        name
      }
      department {
        id
        code
        name
      }
      createdBy {
        id
        name
      }
      productActivePeriods {
        id
        activeFrom
        activeTo
      }
    },
  },
`;
